import styled from 'styled-components';

const CardReview = styled.div`
	margin: 0 0 56px 0;
`;

export default CardReview;
